export type ScrollTargetId = string;

const targets = new Map<ScrollTargetId, HTMLElement>();

const createTarget = (id: ScrollTargetId) => {
    // console.log("create", id, targets);
    if (!id) return;
    const parsedId = id.replace(/\s/g, "-");
    return <div
        id={parsedId}
        ref={element => {
            if(element) targets.set(parsedId, element);
            else targets.delete(parsedId);
        }}
    />;
};

function scrollToTarget(id: ScrollTargetId, arg?: boolean | ScrollIntoViewOptions) {
    if (!id) return;
    const parsedId = id.replace(/\s/g, "-");
    // console.log("scroll", parsedId, targets, targets.get(parsedId));
    targets.get(parsedId)?.scrollIntoView(arg);
}

function useScroller() {
    return {
        createTarget,
        scrollToTarget,
        targets
    };
};

export { useScroller };